<template>
  <a-layout :class="{ layout: 'true', device }" :style="layoutStyle">
    <a-drawer
      v-if="isMobile()"
      :width="230"
      placement="left"
      :wrap-class-name="`drawer-sider ${navTheme}`"
      :closable="false"
      :visible="!sidebarOpened"
      @close="drawerClose"
    >
      <side-menu
        mode="inline"
        :menus="menus"
        :normal-menus="sideBarMenu"
        :theme="navTheme"
        :collapsed="false"
        :collapsible="true"
        @menuSelect="menuSelect"
      ></side-menu>
    </a-drawer>

    <!-- layout header -->
    <global-header
      :mode="layoutMode"
      :menus="menus"
      :normal-menus="sideBarMenu"
      :nav-id="[navId]"
      :navs="navs"
      :theme="navTheme"
      :collapsed="sidebarOpened"
      :device="device"
      @filterMenu="filterMenu"
      @changeColor="changeColor"
      @toggle="toggle"
    />
    <a-layout id="content" :class="{ topmenu: !isSideMenu() }">
      <a-layout-sider
        v-if="!isMobile() && isSideMenu()"
        width="230"
        :theme="navTheme"
        :collapsed="!sidebarOpened"
      >
        <!-- SideMenu -->
        <a-drawer
          v-if="isMobile()"
          :width="230"
          placement="left"
          :wrap-class-name="`drawer-sider ${navTheme}`"
          :closable="false"
          :visible="!sidebarOpened"
          @close="drawerClose"
        >
          <side-menu
            mode="inline"
            :menus="menus"
            :normal-menus="sideBarMenu"
            :theme="navTheme"
            :collapsed="false"
            :collapsible="true"
            @menuSelect="menuSelect"
          ></side-menu>
        </a-drawer>
        <side-menu
          v-else-if="isSideMenu()"
          mode="inline"
          :menus="menus"
          :normal-menus="sideBarMenu"
          :theme="navTheme"
          :collapsed="!sidebarOpened"
          :collapsible="true"
        />
      </a-layout-sider>

      <!-- https://blog.csdn.net/oZhangBi/article/details/79939969 -->
      <!-- <router-view :key="$route.fullPath" /> -->
      <!-- 缓存:{{keepAlive}} -->
      <water-mark v-if="waterMarkContent" :content="waterMarkContent"></water-mark>
      <a-layout-content class="main-container-wrap fbv" :style="mainPageStyle">
        <!-- layout content -->
        <multi-tab v-if="multiTab" :class="{ 'ant-header-fixedTab': fixedHeader }"></multi-tab>

        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="keepAlive">
            <router-view />
          </keep-alive>
        </transition>
      </a-layout-content>
      <!-- Setting Drawer (show in development mode) -->
      <setting-drawer v-if="preview"></setting-drawer>
    </a-layout>
    <feed-back
      v-if="!isMobile()"
      :client-id="clientId"
      :app-id="appId"
      :env="env"
      it-url="https://applink.feishu.cn/T8D9tnSkFVDQ"
    />
  </a-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import WaterMark from '@ecarx-sparrow/et-ui/packages/WaterMark';
import FeedBack from '@ecarx-sparrow/et-ui/packages/FeedBack';
import { mixin, mixinDevice } from '@/utils/mixin';
import { toTreeData, getTopData, triggerWindowResizeEvent } from '@/utils';
import config from '@/config/defaultSettings';
// import RouteView from './RouteView';
import MultiTab from './components/MultiTab';
import SideMenu from './components/Menu/SideMenu.vue';
import GlobalHeader from './components/GlobalHeader';
import SettingDrawer from './components/SettingDrawer';

export default {
  name: 'Layout',
  mixins: [mixin, mixinDevice],
  components: {
    // RouteView,
    MultiTab,
    SideMenu,
    GlobalHeader,
    SettingDrawer,
    WaterMark,
    FeedBack,
  },

  data() {
    return {
      waterMarkContent: '',
      production: config.production,
      preview: process.env.VUE_APP_PREVIEW === 'true',
      clientId: process.env.VUE_APP_CLIENT_ID,
      appId: `${process.env.VUE_APP_MONITOR_ID}`,
      env: `${
        process.env.VUE_APP_MONITOR_ENV === 'production' ||
        process.env.VUE_APP_MONITOR_ENV === 'prd'
          ? 'prd'
          : 'test'
      }`,
    };
  },
  computed: {
    // map vuex中数据
    ...mapState({
      keepAlive: (state) => state.system.page.keepAlive,
      sideBarMenu: (state) => state.system.menu.sideBarMenu,
      // 顶部导航菜单选中项
      navId: (state) => state.system.menu.navId,
      // 顶部导航数组
      navs: (state) => {
        if (state.system.app.navMenu) {
          return getTopData(state.system.menu.sideBarMenu, {
            idField: 'id',
            nameField: 'name',
            parentIDField: 'parentId',
            parentNameField: 'parentName',
          });
        }
        return [];
      },
      // 左侧菜单数组，依赖接口数据以及navId
      menus: (state) => {
        let navId = '';
        if (state.system.app.navMenu) {
          ({ navId } = state.system.menu);
        }
        return toTreeData(
          state.system.menu.sideBarMenu,
          {
            idField: 'id',
            nameField: 'name',
            parentIDField: 'parentId',
            parentNameField: 'parentName',
            navId,
          },
          state.system.menu.menuKeyword
        );
      },
      contentPaddingLeft() {
        if (!this.fixSidebar || this.isMobile()) {
          return '0';
        }
        if (this.menus.length === 0) {
          return '0';
        }
        if (this.sidebarOpened) {
          return '180px';
        }
        return '80px';
      },
      mainPageStyle() {
        if (this.fixedHeader) {
          if (this.multiTab) {
            return {
              paddingTop: '40px',
            };
          }
          return {};
        }
        if (this.multiTab) {
          return {};
        }
        return {};
      },
      layoutStyle() {
        if (this.fixedHeader) {
          return {
            height: '100%',
            paddingTop: '52px',
          };
        }
        return {
          minHeight: '100%',
        };
      },
    }),
    // end mapState
  },
  methods: {
    ...mapActions('system/app', ['setSidebar', 'ToggleColor']),
    ...mapActions('system/menu', ['saveNavMenu']),
    toggle() {
      this.setSidebar(!this.sidebarOpened);
      setTimeout(() => {
        triggerWindowResizeEvent();
      }, 0);
    },
    // 顶部导航菜单变化时
    filterMenu(nav) {
      if (nav.url) {
        this.$router.push({ path: nav.url });
      }
      this.saveNavMenu(nav.id);
    },
    menuSelect() {},
    drawerClose() {
      this.setSidebar(true);
    },
    changeColor(color) {
      if (this.primaryColor !== color) {
        this.ToggleColor(color);
      }
    },
  },
  mounted() {
    const userInfo = this.$store.state.system.user || {};
    this.waterMarkContent = `${userInfo.name || ''}${userInfo.mobile || ''}`;
  },
};
</script>

<style lang="less" scoped>
.layout-wrap {
  // 头部滚动
  height: 100%;
}
.main-container {
  position: relative;
  &.ant-layout-content {
    flex-basis: 0;
  }
}
</style>
